import {Map} from 'immutable';

import {
  SET_POI,
  RESET_POI,
  SET_POI_DUPLICATES,
  RESET_POI_DUPLICATES,
} from './actions';

const server = (state = Map({ poisMap: Map(), duplicatesMap: Map()}), action) => {
    switch (action.type) {
      case SET_POI:
        return state.setIn(['poisMap', action.payload.poi.poi._id], action.payload.poi);
      case RESET_POI:
        return state.removeIn(['poisMap', action.payload.poiId]);
      case SET_POI_DUPLICATES:
        return state.setIn(['duplicatesMap', action.payload.poiId], action.payload.duplicates);
      case RESET_POI_DUPLICATES:
        return state.setIn(['duplicatesMap', action.payload.poiId], []);
      default:
        return state;
    }
};

export default server;


// WEBPACK FOOTER //
// ./src/pois/serverReducers.js